// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "submit-BGUkB";
export { _1 as "__esModule", _2 as "submit" }
export default { "__esModule": _1, "submit": _2 }
